import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import { UserService } from '../../../services/user.service';
import { saveAs } from 'file-saver/FileSaver';
import { ApiConnectService } from '../../../services/api-connect.service';
import { LanguageSwitcher } from '../../../header/language-switcher/language-switcher.model';
import { ViewDocxComponent } from '../../views/view-docx/view-docx.component';
import { ViewDocxService } from '../../../services/view-docx.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDelete } from '../../../modals/confirmDelete/confirmDelete.component';
import { StepsControllerService } from '../../../services/steps-controller.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
	selector: 'app-all-standards',
	templateUrl: './all-standards.component.html',
	styleUrls: ['./all-standards.component.css']
})
export class AllStandardsComponent implements OnInit, OnDestroy {
	noStandardsInfo = true;
	getStandardErrorInfo = false;
	isLoaded = false;
	allStandardList: any;
	sortDirection = true; // false;
	standardNotFound = false;
	errorMessage = false;
	currentSearchValue = '';
	currentPage = 0;
	currentStatus = '';
	clearFilterStatus = '';
	p = localStorage.getItem('lastPage') ? Number(localStorage.getItem('lastPage')) : 1; // current page for ngx-pagination
	totalItems = 0; // totalItems for ngx pagination
	currentSortId = 'number,asc';

	statusList = ['ACTIVE', 'NEW', 'INACTIVE', 'UNDER_CONFIRMATION', 'UNDER_FAMILIARIZATION', this.clearFilterStatus];

	constructor(private adminService: AdminService,
		private userService: UserService,
		private modalService: NgbModal,
		public viewDocxService: ViewDocxService,
		private apiConnectService: ApiConnectService,
		public languageSwitcher: LanguageSwitcher,
		public stepsControllerService: StepsControllerService,
		private route: ActivatedRoute,
		public router: Router) {
	}

	ngOnInit() {

		this.currentStatus = this.clearFilterStatus;

		// GET ALL STANDARDS ON INIT
		if(this.route.snapshot.params['id']) {
			this.getAllStandardsAPIById(this.route.snapshot.params['id']);
		} else {
			this.getAllStandardsAPI();
		}


	}

	ngOnDestroy() {
		if (localStorage.getItem('prevRoute') === '/dashboard/admin/all-standards' && localStorage.getItem('nextRoute').indexOf('/dashboard/standard') === -1) {
			localStorage.removeItem('lastPage');
		}
		if(localStorage.getItem('prevRoute') === '/dashboard/admin/all-standards-head') {
			localStorage.removeItem('lastPage');
		}
		localStorage.removeItem('lastPage');
	}

	// GET ALL STANDARDS FROM API
	getAllStandardsAPI() {
		this.adminService.getAllStandards().subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.getStandardErrorInfo = false;

					if (this.allStandardList.length > 0) {
						this.noStandardsInfo = false;
					} else {
						this.totalItems = 0;
						this.noStandardsInfo = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.noStandardsInfo = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.noStandardsInfo = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}

	getAllStandardsAPIById(id) {
		this.adminService.getAllStandardsById(id).subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.getStandardErrorInfo = false;

					if (this.allStandardList.length > 0) {
						this.noStandardsInfo = false;
					} else {
						this.totalItems = 0;
						this.noStandardsInfo = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.noStandardsInfo = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.noStandardsInfo = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}
	
	// SEARCH FOR SPECIFIC VALUE
	searchValue(value) {
		this.currentStatus = this.clearFilterStatus;
		this.currentSearchValue = value;
		this.adminService.getAllStandardsByValue(value.trim()).subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.getStandardErrorInfo = false;
					if (this.allStandardList.length > 0) {
						this.standardNotFound = false;
					} else {
						this.standardNotFound = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.standardNotFound = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.standardNotFound = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}

	editThisStandard(standardID) {
		this.setTempStandardForEditing(standardID);
	  }

	setTempStandardForEditing(id) {
		this.adminService.getTempStandard(id).subscribe(
		  (res: any) => {
			if (res.status === 200) {
			  const tmpStnd = res.body;
			  tmpStnd.status = "ON_EDITING";
			  this.stepsControllerService.activeStep = 8;
			  this.stepsControllerService.setTempParrentID(id);
			  this.stepsControllerService.setCurrentStandard(tmpStnd);
			}
	  })
	}

	// FILTER LIST BY STATUS
	filterByStatus(status) {
		if (status === this.clearFilterStatus) {
			this.clearAllFilter();
		} else {
			this.currentStatus = status;
			this.getFilteredStatus();
		}
	}


	// GET FILTERED LIST BY STATUS FROM API
	getFilteredStatus() {
		this.adminService.getFilteredStandards(this.currentSearchValue.trim(), this.currentStatus).subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.getStandardErrorInfo = false;
					if (this.allStandardList.length > 0) {
						this.standardNotFound = false;
					} else {
						this.standardNotFound = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.standardNotFound = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.standardNotFound = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}

	clearAllFilter() {
		this.currentStatus = this.clearFilterStatus;
		this.getFilteredStatus();
	}

	// SORT LIST BY sortId // // // // // //
	// sortId values:
	// 'number, asc' is using by default
	// 'number,asc' or 'number,desc'
	// 'ruName,asc' or 'ruName,desc'
	// 'enName,asc' or 'enName,desc'
	// 'ruType,asc' or 'ruType,desc'
	// 'enType,asc' or 'enType,desc'
	// 'status,asc' or 'status,desc'
	// // // // // // // // // // // // //
	sortList(sortId) {

		if (this.sortDirection) {
			sortId += ',desc';
			this.sortDirection = !this.sortDirection;
			this.currentSortId = sortId;
		} else {
			sortId += ',asc';
			this.sortDirection = !this.sortDirection;
			this.currentSortId = sortId;
		}
		this.getSortedList(sortId);

	}

	// GET SORDET LIST FROM API
	getSortedList(sortId) {
		const pageNumb = this.p - 1;
		this.adminService.getSortedStandards(pageNumb, sortId, this.currentSearchValue.trim(), this.currentStatus).subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.getStandardErrorInfo = false;
					if (this.allStandardList.length > 0) {
						this.standardNotFound = false;
					} else {
						this.standardNotFound = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.standardNotFound = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.standardNotFound = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}


	openDocModal(docxID, sID) {

		localStorage.setItem('DocxID', docxID);
		localStorage.setItem('DocxSID', sID);

		const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
		modalRef.result.then((result) => {
			if (result === 'Close') {
				// on close button
				this.viewDocxService.deleteLinkByDocxID();
			}
		}, (reason) => {
			// on dismiss
			this.viewDocxService.deleteLinkByDocxID();
		});

	}

	openDocModalDOCX(fileLink) {
		localStorage.setItem('fileLink', fileLink);

		const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
		modalRef.result.then((result) => {
			if (result === 'Close') {
				// on close button
				this.viewDocxService.deleteLinkByDocxIDManually();
			}
		}, (reason) => {
			// on dismiss
			this.viewDocxService.deleteLinkByDocxIDManually();
		});
	}


	downloadFile(fileId: string) {
		this.userService.getFile(fileId).subscribe(
			(response: any) => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(response.body);
				link.download = response.headers.get('filename');
				link.click();
				link.remove();
			},
			() => {
			}
		);
	}

	openPdf(fileId: string) {
		window.open(this.apiConnectService.getPdf + fileId, '_blank');
	}

	getPage(page: number) {
		if(this.route.snapshot.params['id']) {
			this.getPageAPII(page);
		} else {
			this.getPageAPI(page);
		}
	}

	// GET PAGE FROM API
	getPageAPI(pageNumber: number) {
		const page = pageNumber - 1;
		localStorage.setItem('lastPage', pageNumber.toString());
		this.adminService.getPageServer(page, this.currentSearchValue.trim(), this.currentStatus, this.currentSortId).subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.p = pageNumber;
					this.getStandardErrorInfo = false;
					if (this.allStandardList.length > 0) {
						this.standardNotFound = false;
					} else {
						this.standardNotFound = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.standardNotFound = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.standardNotFound = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}

	getPageAPII(pageNumber: number) {
		const page = pageNumber - 1;
		localStorage.setItem('lastPage', pageNumber.toString());
		this.adminService.getPageServera(this.route.snapshot.params['id'], page, this.currentSearchValue.trim(), this.currentStatus, this.currentSortId).subscribe(
			(response: any) => {
				if (response.status === 200) {
					const res = response.body;
					this.allStandardList = res.content;
					this.totalItems = res.totalElements;
					this.p = pageNumber;
					this.getStandardErrorInfo = false;
					if (this.allStandardList.length > 0) {
						this.standardNotFound = false;
					} else {
						this.standardNotFound = true;
					}
				}
				if (response.status === 204) {
					this.getStandardErrorInfo = false;
					this.standardNotFound = true;
				}
				this.isLoaded = true;

			},
			() => {
				this.standardNotFound = true;
				this.getStandardErrorInfo = true;
				this.isLoaded = true;
			}
		);
	}

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/all-standards/all-standards.component.ts